var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.pnpm/@angular-devkit+build-angular@21.2.14_@angular+compiler-cli@21.2.16_@angular+compiler@2_0c20d1d512fcd65808e47b4b0c5e1948/node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/.pnpm/source-map-loader@5.0.0_webpack@5.105.2_@swc+core@1.15.8_@swc+helpers@0.5.18__esbuild@0_99bc3a8ba370c24c4a49d32dec26c567/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.3eebd6a1a02e5eefe194932bb3730c41.js */ 91787);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};